import { useAuth } from '@/contexts/AuthContext';
import Skeleton from '@common/components/Skeleton';
import { Button } from '@common/index';
import dayjs from 'dayjs';
import React from 'react';
import styles from './ProfileModal.module.scss';

const BillingContent: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const { userBilling, openPricingModal } = useAuth();
    const {
        invoices, loading, userPlan, planText
    } = userBilling;
    const {invoices: data, pagination} = invoices || {};
        
    return (
        <div className={styles.usageContent}>
            <div>
                <div className={styles.sectionTitle}>Current plan</div>
                <div className={styles.plan}>
                    <div className={styles.planInfo}>
                        <div>
                            <div className={styles.planName}>
                                {userPlan?.planCode === 'FREE' ? 'Basic' : planText.planDisplayText}
                                {userPlan?.planCode === 'FREE' && (
                                    <span className={styles.planTag}>
                                        {planText.planDisplayText}
                                    </span>
                                )}
                            </div>
                            <div className={styles.expiration}>
                                {planText.expirationText}
                                {' '}
                                <span>{dayjs(userPlan?.endAt).format('MMM D, YYYY')}</span>
                            </div>
                        </div>
                        {planText.buttonText === 'Upgrade'
                            ? (
                                <Button
                                    size="2"
                                    color="primary"
                                    onClick={() => {
                                        openPricingModal()
                                        onClose()
                                    }}
                                >
                                    {planText.buttonText}
                                </Button>
                            ): (
                                <Button
                                    variant="outline"
                                    size="2"
                                    color="gray"
                                    onClick={() => {
                                        openPricingModal()
                                        onClose()
                                    }}
                                >
                                    {planText.buttonText}
                                </Button>
                            )}
                    </div>
                </div>
            </div>

            <div>
                <div className={styles.sectionTitle}>Billing History</div>
                <div className={styles.usageTable}>
                    <div className={styles.tableHeader}>
                        <div className={styles.headerCell}>Transaction ID</div>
                        <div className={styles.headerCell}>Date</div>
                        <div className={styles.headerCell}>Total Amount</div>
                    </div>
                    <div className={styles.tableBody}>
                        {data && data.length > 0 ? (
                            data.map((item) => (
                                <div key={item.id} className={styles.tableRow}>
                                    <div className={styles.tableCell}>{item.id || 'Unknown Task'}</div>
                                    <div className={styles.tableCell}>
                                        {new Date(item.created_at).toLocaleString()}
                                    </div>
                                    <div className={styles.tableCell}>
                                        <span className={styles.creditsChange}>
                                            {(item.amount_cents/100).toFixed(2)} 
                                            {' '}
                                            {item.currency.toUpperCase()}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className={styles.billingEmpty}>
                                Billing history is not available.
                            </div>
                        )}
                        
                        {/* 加载更多指示器 */}
                        {loading.invoices && pagination?.hasNext ? (
                            <Skeleton style={{ width: '100%', height: '70px' }} />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BillingContent;